<mat-dialog-content class="mat-typography">
        <div class="p-[1rem] flex flex-col items-center">
            <div *ngIf="!policy && !loading" class="w-full policy-page max-w-xl">

                <h1>Política de privacidad</h1>

                <h2>1.- ¿Quién es el responsable del tratamiento de sus datos?</h2>

                <p>El responsable del tratamiento de sus datos personales es ALL4LEND S.L.,(en adelante, “BELENDER”), con N.I.F.: B-67425769 y domicilio social en Calle del Sol 19, Sant Andreu de la Barca, 08740, Barcelona, España.</p>
                
                <p>Le informamos que la titularidad de este Sitio Web (en adelante, el “Sitio Web”), es de BELENDER.</p>
                
                <p>El acceso y/o uso del Sitio Web, le atribuye la condición de Usuario (en adelante, el «Usuario»), e implica la aceptación, desde dicho acceso y/o uso, de la presente Política de Privacidad.</p>
                
                <p>El Usuario podrá contactar con BELENDER en la siguiente dirección de correo electrónico: {{'DPO@belender.eu'}}</p>


                
                <h2>2.- ¿Por qué BELENDER está legitimado para llevar a cabo el tratamiento de datos?</h2>
                
                <p>BELENDER está legitimada para tratar sus datos para poder llevar a cabo la prestación de sus servicios.</p>
                
                <p>BELENDER se toma muy en serio la protección de su privacidad y de sus datos personales. Por lo tanto, su información personal se conserva de forma segura y se trata con el máximo cuidado.</p>
                
                <p>La presente Política de Privacidad regula el acceso y el uso al servicio (en adelante, el “Servicio”) que BELENDER pone a disposición del Usuario interesado en los servicios.</p>
                
                <p>En este sentido, las bases de legitimación utilizadas por BELENDER para el tratamiento de los datos de los Usuarios son:</p>

                <ul>
                    <li>La ejecución de un contrato en el que el Usuario es parte.</li>
                    <li>El consentimiento de los Usuarios al tratamiento de sus datos personales para las finalidades especificadas en cada caso.</li>
                </ul>


                
                <h2>3.- ¿Cuáles son las finalidades del tratamiento de sus datos de carácter personal por parte de BELENDER?</h2>
                
                <p>Sus datos de carácter personal recabados por BELENDER podrán ser utilizados para las siguientes finalidades, según el consentimiento otorgado en el formulario de registro correspondiente:</p>
                
                <p>La prestación de los servicios de BELENDER.</p>
                
                <p>Para la prestación del servicio demandado por el Usuario, BELENDER necesitará tratar datos personales obtenidos a partir de la información que el Usuario facilite a BELENDER</p>
                
                <p>El envío de comunicaciones comerciales y/o Newsletter por parte de BELENDER:</p>
                
                <p>Esta finalidad será el envío al usuario registrado, por carta, teléfono, correo electrónico, SMS/MMS, o por otros medios de comunicación electrónica equivalentes por parte de BELENDER de información y comunicaciones comerciales sobre los Servicios que puedan resultar de su interés.</p>
            

                
                <h2>4.- Veracidad de los datos facilitados por los Usuarios</h2>
                
                <p>El Usuario garantiza que los datos personales facilitados son veraces y se hace responsable de comunicar a BELENDER cualquier modificación de estos. El Usuario responderá, en cualquier caso, de la veracidad de los datos facilitados, reservándose BELENDER el derecho a excluir de los Servicios registrados a todo Usuario que haya facilitado datos falsos, sin perjuicio de las demás acciones que procedan en Derecho.</p>
                
            

                <h2>5.-Conservación de los datos</h2>
                
                <p>Los datos personales proporcionados se conservarán por parte de BELENDER mientras el Usuario no manifieste su voluntad de darse de baja de los servicios de BELENDER, y ello con la finalidad de recibir información sobre productos de BELENDER. Posteriormente, en caso de ser necesario, BELENDER mantendrá la información bloqueada los plazos legalmente establecidos.</p>
                
            

                <h2>6.- Derechos del Usuario en relación con sus datos</h2>
                
                <p>El Usuario tiene derecho a:</p>
                
                <ul>
                    <li>Acceder a sus datos personales.</li>
                    <li>Solicitar la rectificación de los datos inexactos</li>
                    <li>Solicitar su supresión.</li>
                    <li>Solicitar la limitación del tratamiento de sus datos.</li>
                    <li>Oponerse al tratamiento de sus datos.</li>
                    <li>Solicitar su portabilidad.</li>
                    <li>No ser objeto de decisiones individuales automatizadas.</li>
                    
                </ul>
                
                <p>El Usuario puede ejercer todos estos derechos a través de la siguiente dirección de email {{'DPO@belender.eu'}} indicando el motivo de su petición y aportando una copia de su D.N.I.</p>
                
                <p>El Usuario puede también enviar su petición por correo ordinario a la siguiente dirección:</p>

                <div class="p-3 rounded-md mt-3 mb-3 bg-slate-100">
                    <p>ALL4LEND S.L.</p>
                    <p> N.I.F.: B-67425769</p>
                    <p>Calle del Sol 19, Sant Andreu de la Barca, 08740, Barcelona.</p>
                </div>
                
                <p>Sin perjuicio de cualquier otro recurso administrativo o acción judicial, el Usuario tendrá derecho a presentar una reclamación ante una Autoridad de Control, en particular en el Estado miembro en el que tenga su residencia habitual, lugar de trabajo o lugar de la supuesta infracción, en caso de que considere que el tratamiento de sus datos personales no es adecuado a la normativa, así como en el caso de no ver satisfecho el ejercicio de sus derechos. La autoridad de control ante la que se haya presentado la reclamación informará al reclamante sobre el curso y el resultado de la reclamación.</p>
                


                <h2>7.- Seguridad de los datos</h2>
                
                <p>La protección de la privacidad y los datos personales de los Usuarios es muy importante para BELENDER. Por lo tanto, BELENDER hace todo lo que está en su mano para impedir que sus datos se utilicen de forma inadecuada, permitiendo el acceso a los mismos únicamente a personal autorizado.</p>
                
                <p>BELENDER mantiene los niveles de seguridad de protección de datos personales conforme a la normativa aplicable y ha establecido todos los medios técnicos a su alcance para evitar la pérdida, mal uso, alteración, acceso no autorizado y robo de los datos que el Usuario facilite a través del Sitio Web sin perjuicio de informarle de que las medidas de seguridad en Internet no son inexpugnables.</p>
                
                <p>BELENDER se compromete a cumplir con el deber de secreto y confidencialidad respecto de los datos personales de acuerdo con la legislación aplicable, así como a conferirles un tratamiento seguro en las cesiones y transferencias internacionales de datos que, en su caso, puedan producirse.</p>
                
                <p>En aquellos servicios del Sitio Web que precisen registrarse como Usuario, se deberá elegir una contraseña. El Usuario es el responsable de mantener la confidencialidad de esta contraseña, así como de todas las actividades que ocurran en la sesión iniciada con su nombre y contraseña.</p>
                
                <p>El Usuario se compromete a notificar BELENDER a la mayor brevedad el uso no autorizado de su nombre de Usuario y/o contraseña o cualquier otro fallo en la seguridad. BELENDER no será responsable por los daños o pérdidas que se pudieran originar debido al no cumplimiento de esta obligación por parte del Usuario.</p>
                
                <h2>8.-Cambios</h2>
                
                <p>BELENDER se reserva el derecho de revisar su Política de Privacidad en el momento que considere oportuno. Por esta razón, le rogamos que compruebe de forma regular esta Política de Privacidad para leer la versión más reciente de la misma.</p>
                
                <p>No obstante, cualquier cambio que se produzca en la presente Política de Privacidad se comunicará al Usuario.</p>
                
                
                
                <h2>9.- Links a páginas web</h2>
                
                <p>EL Sitio Web de BELENDER podría contener links a páginas web de compañías y entidades de terceros. BELENDER no puede hacerse responsable de la forma en la que estas compañías tratan la protección de la privacidad y de los datos personales, por lo que le aconsejamos que lea detenidamente las declaraciones de Política de Privacidad de estas páginas web que no son propiedad de BELENDER con relación al uso, procesamiento y protección de datos personales.</p>
                
                <p>Las condiciones que ofrecen estas páginas web pueden no ser las mismas que las que ofrece BELENDER.</p>


                
                <h2>10.- Preguntas</h2>
                
                <p>Si tienen alguna pregunta sobre esta Política de Privacidad o el tratamiento de sus datos rogamos que se ponga en contacto con BELENDER mediante correo electrónico dirigido a la siguiente dirección de correo electrónico: {{'DPO@belender.eu'}}</p>
               

                
                <h2>11.- Aceptación y Consentimiento.</h2>
                
                <p>El Usuario declara haber sido informado de las condiciones sobre protección de datos personales, aceptando y consintiendo el tratamiento de estos por parte de BELENDER, en la forma y para las finalidades indicadas en la presente Política de Privacidad.</p>
            </div>

            <ng-container *ngIf="policy && !loading">
                <div class="w-full max-w-xl policy-page" [innerHTML]="policy"></div>
            </ng-container>

            <div *ngIf="loading" class="w-full px-8 py-16 rounded-md bg-blue-500/20 text-blue-500 text-center">
                Cargando políticas de privacidad
            </div>
        </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button 
    [style.border-radius]="funderStyles.btnRound + 'px'"
    class="px-8 bg-slate-300/30" 
    mat-flat-button mat-dialog-close>Cancelar</button>
  <button         
    [style.color]="funderStyles.colors.btnText"
    [style.background]="funderStyles.colors.btnBg"
    [style.border-radius]="funderStyles.btnRound + 'px'"
    class="px-8" 
    mat-flat-button type="button" [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>
